import { render, staticRenderFns } from "./StorageLocation.vue?vue&type=template&id=e707d9cc&scoped=true"
import script from "./StorageLocation.vue?vue&type=script&lang=js"
export * from "./StorageLocation.vue?vue&type=script&lang=js"
import style0 from "./StorageLocation.vue?vue&type=style&index=0&id=e707d9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e707d9cc",
  null
  
)

export default component.exports